import { getDeviseConfig, DEVISE_DEFAUT } from '../config/devises';

/**
 * Formate un montant selon la devise du commerçant.
 * @param {number} amount
 * @param {string} deviseCode - EUR | MAD
 */
export function formatMoney(amount, deviseCode = DEVISE_DEFAUT) {
  const code = deviseCode || DEVISE_DEFAUT;
  const cfg = getDeviseConfig(code);

  if (code === 'MAD') {
    const value = Number(amount) || 0;
    return `${value.toLocaleString('fr-MA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${cfg.symbole}`;
  }

  return new Intl.NumberFormat(cfg.locale, {
    style: 'currency',
    currency: 'EUR',
  }).format(amount || 0);
}
